import { APP_NAMESPACE } from '@/_constants/i18next/app-namespace';
import { WAREHOUSES_LIMITS_PAGE_NAMESPACE } from './page-sub-namespace';

export const WAREHOUSES_LIMITS_PAGE_TRANSLATIONS = {
  startingFromDate: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.startingFromDate`,
  boxesAmount: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.boxesAmount`,
  palettesAmount: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.palettesAmount`,
  superSafeAmount: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.superSafeAmount`,
  boxesTableName: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.boxesTableName`,
  palettesTableName: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.palettesTableName`,
  superSafeTableName: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.superSafeTableName`,
  instruction: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.instruction`,
  warehousesFetchError: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.warehousesFetchError`,
  limitsFetchError: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.limitsFetchError`,
  instructionCoefficient: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.instructionCoefficient`,
  warehouse: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.warehouse`,
  warehouseNotFound: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.warehouseNotFound`,
  chooseWarehouseDescription: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.chooseWarehouseDescription`,
  coefficientsExamples: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.coefficientsExamples`,
  coefficient: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.coefficient`,
  value: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.value`,
  free: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.free`,
  freeAcceptance: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.freeAcceptance`,
  equalToBaseCost: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.equalToBaseCost`,
  acceptanceFeeIncreased: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.acceptanceFeeIncreased`,
  all: `${APP_NAMESPACE}:${WAREHOUSES_LIMITS_PAGE_NAMESPACE}.all`,
};
